var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 309,
    viewBox: "0 0 164 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.673 307.659C305.285 288.743 301.578 284.624 286.762 265.216C283.132 260.461 277.42 251.217 271.965 239.799C270.331 236.383 268.848 232.994 267.489 229.654C257.795 205.746 256.427 178.963 258.679 152.512C264.429 85.0233 227.897 24.1114 172.586 6.35408C117.18 -11.4317 55.6535 17.8285 25.6316 63.4887C21.7256 69.4299 4.49558 97.4658 1.94862 128.225C-6.11995 225.345 87.9563 264.153 231.1 293.536C233.884 294.106 247.142 296.279 249.955 296.668L328.683 307.668L328.673 307.659Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector24);
export default __webpack_public_path__ + "static/media/vector2-4.1440bf0f5437ce3e1f9e6c0f70e03bd2.svg";
export { ForwardRef as ReactComponent };